import { supabase } from './supabase';

/**
 * Lists all saved bookings (joined to account email) after admin gate RPC check.
 */
export async function fetchBookingsForAdmin(adminEmail, adminPassword) {
  const { data, error } = await supabase.rpc('admin_list_bookings', {
    p_admin_email: adminEmail,
    p_admin_password: adminPassword,
  });

  if (error) {
    throw new Error(error.message || 'Request failed');
  }

  if (!data || data.success !== true) {
    throw new Error(data?.error || 'Could not load bookings');
  }

  const raw = data.bookings;
  if (Array.isArray(raw)) return raw;
  return [];
}
